import { useContext } from "react";
import { Cable } from "lucide-react";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { ContainerActions, ContainerPageNavigation, ContainerSearch, ContainerIntegrations } from "./";
import { ModalCreateIntegration, ModalDeleteIntegration, ModalIntegration } from "./modals";
import ResendCard from "./ResendCard";
import SesCard from "./SesCard";
// LastlinkCard (API pública da Lastlink): código pronto, mas a conta do dono não tem a API habilitada
// ("apenas integrações de terceiros", 2026-10-14). Integração é só por webhook; remontar quando a API aparecer.
// import LastlinkCard from "./LastlinkCard";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 animate-fade-in">
                        <div className="space-y-1">
                            <span className="label-overline">Configuração</span>
                            <h1 className="display-2 flex items-center gap-3">
                                Integrações
                                <Cable className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Webhooks de Hotmart, Kiwify e Lastlink por empresa — copie a URL única e cole no painel da plataforma. E-mail transacional via Resend ou Amazon SES.
                            </p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-3">
                            <ContainerSearch />
                            <ContainerActions />
                        </div>
                    </header>

                    <ResendCard />
                    <SesCard />
                    {/* <LastlinkCard /> */}

                    <ContainerIntegrations />
                    <ContainerPageNavigation />

                </div>

                <ModalCreateIntegration />
                <ModalDeleteIntegration />
                <ModalIntegration />
            </div>
        </div>
    );
}
